import React from 'react'
import TextInput from './inputs/TextInput'
import Icon from '@material-ui/core/Icon';
import Grid from '@material-ui/core/Grid';

import {
  isNumeric,
  isUnsigned
} from "../validators"

class LevelSubForm extends React.Component {
  render() {
    const {levelname, parentstate, track, base, numOfCols} = this.props
    return (
      <Grid container>
        <Grid container item xl={numOfCols}>
          <div className="d-flex align-items-center cefr-level-wrapper">
            <span className="cefr-level fw-bold body1 level-name">{levelname}</span>
            <div className="small-input">
              <TextInput
                id={`${base}-level-right-${levelname}`}
                model={track(`${base}.levels[].score_right`, (lev) => lev && lev.name === levelname)}
                error={parentstate.score_right}
                required
                helperText="Pts Correct"
                validators={{
                  required: val=> isNumeric(val)
                }}
              />
            </div>
            <div className="small-input">
              <TextInput
                id={`${base}-level-wrong-${levelname}`}
                model={track(`${base}.levels[].score_wrong`, (lev) => lev && lev.name === levelname)}
                className="smallInput"
                error={parentstate.score_wrong}
                required
                helperText="Pts Wrong"
                validators={{
                  required: val=> isUnsigned(val)
                }}
              />
            </div>
            <div className="small-input">
              <TextInput
                id={`${base}-level-msr-${levelname}`}
                model={track(`${base}.levels[].msr`, (lev) => lev && lev.name === levelname)}
                className="smallInput"
                error={parentstate.msr}
                required
                helperText="MSR %"
                validators={{
                  required: val=> isNumeric(val, levelname === "C2", 100) // max = 100
                }}
              />
            </div>
            <div className="small-input">
              <TextInput
                id={`${base}-level-minavg-${levelname}`}
                model={track(`${base}.levels[].min_average`, (lev) => lev && lev.name === levelname)}
                className="smallInput"
                error={parentstate.min_average}
                required
                helperText="Min AVG"
                validators={{
                  required: val=> isNumeric(val)
                }}
              />
            </div>
            <div className="small-input">
              <TextInput
                id={`${base}-level-up-${levelname}`}
                model={track(`${base}.levels[].level_up`, (lev) => lev && lev.name === levelname)}
                className="smallInput"
                error={parentstate.level_up}
                required
                helperText={(<span>#Qs <Icon style={{fontSize: '16px'}}>arrow_upward</Icon></span>)}
                validators={{
                  required: val=> isNumeric(val, levelname === "C2")
                }}
              />
            </div>
            <div className="small-input">
              <TextInput
                id={`${base}-level-down-${levelname}`}
                model={track(`${base}.levels[].level_down`, (lev) => lev && lev.name === levelname)}
                className="smallInput"
                error={parentstate.level_down}
                required
                helperText={(<span>#Qs <Icon style={{fontSize: '16px'}}>arrow_downward</Icon></span>)}
                validators={{
                  required: val=> isNumeric(val, levelname === "A1")
                }}
              />
            </div>
          </div>
        </Grid>
      </Grid>
    )
  }
}

export default LevelSubForm



// WEBPACK FOOTER //
// ./src/js/components/LevelSubForm.js